/**
 * Created with IntelliJ IDEA.
 * User: elinar
 * Date: 12/9/14
 * Time: 7:31 PM
 * To change this template use File | Settings | File Templates.
 */

define(function (require) {
    "use strict";

    var ConnectionMainLayout = require("connection-views/ConnectionMainLayout");
    var HandleView = require("connection-views/HandleView");
    var HandleModel = require("connection-models/HandleModel");

    var HandleController = {};
    LE.module('LEConnection', function (LEConnection, LE, Backbone, Marionette, $, _) {
        HandleController = Marionette.Controller.extend({
            initialize: function (options) {
                this.connectionPanelContextModel = options.connectionPanelContextModel;
                this.handleModel = new HandleModel();
                this.handleView = new HandleView({
                    model: this.handleModel,
                    connectionPanelContextModel: this.connectionPanelContextModel,
                    controller: this
                });

                LEConnection.vent.trigger("ConnectionPanelLayoutController:showRegion:handle", {
                    view: this.handleView
                });
                this._bindEvents();
            },

            _bindEvents: function () {
                //this.listenTo(this.connectionPanelContextModel, "change:chatIsActive", this._manageHandleTray);
                this.listenTo(this.connectionPanelContextModel, "change:chatNotificationsCounter", this._updateChatNotifications);
                this.listenTo(this.connectionPanelContextModel, "change:notificationCenterEventsCounter", this._updateNotificationCenterEvents);
                this.listenTo(this.connectionPanelContextModel, "change:hasCriticalNotifications", this._updateNotificationCritical);
                this.listenTo(this.connectionPanelContextModel, "change:newKPsCounter", this._updateNewKPsCounter);
                this.listenTo(this.handleView, "ConnectionPanel:open", this._openConnectionPanel);
                this.listenToOnce(this.handleView, 'render', this._initializeCounterModel);
            },

            _initializeCounterModel: function () {
                this.handleView.model.set("chatNotificationsCounter", this.connectionPanelContextModel.get('chatNotificationsCounter'));
                this.handleView.model.set("notificationCenterEventsCounter", this.connectionPanelContextModel.get('notificationCenterEventsCounter'));
                this.handleView.model.set("hasCriticalNotifications", this.connectionPanelContextModel.get('hasCriticalNotifications'));
                this.handleView.model.set("newKPsCounter", this.connectionPanelContextModel.get('newKPsCounter'));
            },

            _manageHandleTray: function (model, chatIsActive) {
                this.handleModel.set("chatIsActive", chatIsActive);
            },

            _updateChatNotifications: function (model, chatNotificationsCounter) {
                this.handleView.model.set("chatNotificationsCounter", chatNotificationsCounter);
            },

            _updateNotificationCenterEvents: function (model, notificationCenterEventsCounter) {
                this.handleView.model.set("notificationCenterEventsCounter", notificationCenterEventsCounter);
            },

            _updateNotificationCritical: function (model, urgent) {
                this.handleView.model.set("hasCriticalNotifications", urgent);
            },

            _updateNewKPsCounter: function (model, newKPsCounter) {
                this.handleView.model.set('newKPsCounter', newKPsCounter);
            },

            _openConnectionPanel: function () {
                this.connectionPanelContextModel.set("isOpen", true);
            }

        });
    });
    return HandleController;
});

